import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import isEqual from 'date-fns/isEqual'

export const areDatesEqual = (date1: Date, date2: Date) => isEqual(date1, date2)

export const dateToRussianTimezone = (date: Date, revert = false) =>
  revert ? utcToZonedTime(date, 'Europe/Moscow') : zonedTimeToUtc(date, 'Europe/Moscow')
